import { useCallback, useMemo } from "react";
import { useSearch, useNavigate } from "@tanstack/react-router";
import type { AdminSearchParams } from "@/features/admin/types";

export function useDashboardSearchParams() {
  const search = useSearch({
    from: "/admin",
  }) as AdminSearchParams;
  const navigate = useNavigate({ from: "/admin" });

  const sorting = useMemo(() => {
    const sortColumn = search.dashboardSortBy;
    const sortDirection = search.dashboardSortDirection ?? "asc";
    return {
      sortColumn: sortColumn ?? undefined,
      sortDirection: sortDirection as "asc" | "desc",
    };
  }, [search.dashboardSortBy, search.dashboardSortDirection]);

  const updateSearchParams = useCallback(
    (updates: { sortColumn?: string; sortDirection?: "asc" | "desc" }) => {
      const newSearch: AdminSearchParams = { ...search };

      if (updates.sortColumn === undefined) {
        delete newSearch.dashboardSortBy;
        delete newSearch.dashboardSortDirection;
      } else {
        newSearch.dashboardSortBy = updates.sortColumn;
        newSearch.dashboardSortDirection = updates.sortDirection ?? "asc";
      }

      navigate({
        search: newSearch,
        replace: true,
      });
    },
    [search, navigate]
  );

  return {
    sorting,
    updateSearchParams,
  };
}
